import Vue from "vue";
import Router from "vue-router";
import Assess from "./components/Assess";
import Assessment from "./components/Assessment";
import Dashboard from "./components/Dashboard";
import IssueDetail from "./components/IssueDetail2";
import NewScan from "./components/NewScan2";
import ApkScan from "./components/forms/ApkScan"

Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
    },
    {
      path: "/assess",
      name: "assess",
      component: Assess,
    },
    {
      path: "/new",
      name: "new",
      component: NewScan,
    },
    {
      path: "/assess/:assessmentId",
      name: "assessment",
      component: Assessment,
    },
    {
      path: "/assess/:assessmentId/:issueId",
      name: "issuedetail",
      component: IssueDetail,
    },
    {
      path: "/new/apk",
      name: "apkscan",
      component: ApkScan,
    },
  ],
});

export default router;
